<template>
  <div class="caterers">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- banner -->
    <div class="banner">
      <img
        src="../assets/images/pc_banner.png"
        :alt="this.$t('message.menutag')"
      />
      <div class="po">
        <h1>{{ $t("message.menuh1") }}</h1>
        <h2>{{ $t("message.menuh2") }}</h2>
      </div>
    </div>
    <!-- services -->
    <div class="services">
      <div class="center2">
        <ul>
          <li>
            <p>
              <img src="../assets/images/pc_icon1_icon.png" alt />
            </p>
            <p>
              <span>{{ $t("message.menu.span.title1") }}</span>
              <span>{{ $t("message.menu.span.content1") }}</span>
            </p>
          </li>
          <li>
            <p>
              <img src="../assets/images/pc_icon2_icon.png" alt />
            </p>
            <p>
              <span>{{ $t("message.menu.span.title2") }}</span>
              <span>{{ $t("message.menu.span.content2") }}</span>
            </p>
          </li>
          <li>
            <p>
              <img src="../assets/images/pc_icon3_icon.png" alt />
            </p>
            <p>
              <span>{{ $t("message.menu.span.title3") }}</span>
              <span>{{ $t("message.menu.span.content3") }}</span>
            </p>
          </li>
          <li>
            <p>
              <img src="../assets/images/pc_icon4_icon.png" alt />
            </p>
            <p>
              <span>{{ $t("message.menu.span.title4") }}</span>
              <span>{{ $t("message.menu.span.content4") }}</span>
            </p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 餐单 -->
    <!-- <div class="main-section1">
      <div class="block">
        <el-carousel
          trigger="click"
          :height="imgHeight + 'px'"
          arrow="always"
          ref="carouselIitem"
        >
          <el-carousel-item v-for="item in ImageData" :key="item">
            <img :src="item" alt="" ref="image" @click="showImage" />
          </el-carousel-item>
        </el-carousel>
        <div>
          <h2>{{ $t("message.junk.main_section1.h2") }}</h2>
          <h3>{{ $t("message.junk.main_section1.h3") }}</h3>
          <h3>{{ $t("message.junk.main_section1.h5") }}</h3>
          <button class="Btn" @click="open">
            {{ $t("message.junk.main_section1.btn") }}
          </button>
        </div>
      </div>
    </div> -->
    <div class="caterers_menu" style="margin: 0 auto">
      <!-- <div class="caterers_menu_f" style="margin: 1.5em 0">
        <div>
          <img
            v-if="this.$i18n.locale === 'zh'"
            src="../assets/images/2021Halloweenmenu6-8.jpg"
            alt=""
            @click="showImage(0)"
          />
          <img
            v-else
            src="../assets/images/2021Halloweenmenu6-8.jpg"
            alt=""
            @click="showImage(0)"
          />
        </div>
        <div>
          <h2>{{ $t("message.junk.main_section1.h3") }}</h2>
          <h3>{{ $t("message.junk.main_section1.h5") }}</h3>
          <h3>{{ $t("message.junk.main_section1.h6") }}</h3>
          <a
            href="https://cateraway.rakosell.com/zh"
            target="_black"
            v-if="this.$i18n.locale === 'zh'"
          >
            <el-button>{{ $t("message.junk.main_section1.btn") }}</el-button>
          </a>
          <a href="https://cateraway.rakosell.com/en" target="_black" v-else>
            <el-button>{{ $t("message.junk.main_section1.btn") }}</el-button>
          </a>
        </div>
      </div> -->
      <!-- <div class="caterers_menu_f" style="margin: 1.5em 0">
        <div>
          <img
            v-if="this.$i18n.locale === 'zh'"
            src="../assets/images/2021_ChristmasMenu.jpg"
            alt=""
            @click="showImage(1)"
          />
          <img
            v-else
            src="../assets/images/2021_ChristmasMenu.jpg"
            alt=""
            @click="showImage(1)"
          />
        </div>
        <div>
          <h2>{{ $t("message.junk.main_section1.h4") }}</h2>
          <h3>{{ $t("message.junk.main_section1.h5") }}</h3>
          <a
            href="https://cateraway.rakosell.com/zh"
            target="_black"
            v-if="this.$i18n.locale === 'zh'"
          >
            <el-button>{{ $t("message.junk.main_section1.btn") }}</el-button>
          </a>
          <a href="https://cateraway.rakosell.com/zh" target="_black" v-else>
            <el-button>{{ $t("message.junk.main_section1.btn") }}</el-button>
          </a>
        </div>
      </div> -->
    </div>
    <div class="caterers">
      <!-- <div class="zhan">
                <div style="weight:100%;">
                  <div class="main">
                      <div class="m2">
                          <div v-for="cat in setMenus" :key="cat.id">
                              <p>~&nbsp;&nbsp;{{cat.name}}&nbsp;&nbsp;~</p>
                              <div class="sm1">
                                <div v-for="set in cat.menusets" :key="set.id">
                                  <img :src="set.img" alt="" width="100%" height="auto" @click='openDialog(set)'>
                                  <div class="xx">
                                    <p>{{set.name}}</p>
                                    <p>適合人數：{{set.compatibility}}</p>
                                    <p>價格：<span class="pic">$&nbsp;&nbsp;{{set.prices}}</span></p>
                                    <div v-for="(type, id) in set.includeTypes" :key="id" class="icons">
                                      <span v-if="type === 'Royal card'" class="smlogo R"></span>
                                      <span v-if="type === 'suitable for the party'" class="smlogo gg"></span>
                                      <span v-if="type === 'vegan'" class="smlogo b"></span>
                                    </div>
                                    <el-button type="success" size="mini" @click='openDialog(set)'>查看詳情</el-button>
                                  </div>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
      </div>-->
      <div class="zhan">
        <p>
          <!-- <i class="iconfont icon-30jiantouxiangxiafill"></i> -->
        </p>
        <div class="zhan-c">
          <img src="../assets/images/pc_hz_title_line1.png" alt />
          <h2 class="zhanh2">{{ $t("message.menuh") }}</h2>
          <img src="../assets/images/pc_hz_title_line2.png" alt />
          <h2 class="zhanh22">{{ $t("message.menu.h2") }}</h2>
        </div>
        <el-tabs type="border-card">
          <el-tab-pane
            class="card"
            v-for="cat in setMenus"
            :key="cat.id"
            :label="cat.name"
          >
            <div v-for="set in cat.menusets" :key="set.id" class="bbg">
              <img
                :src="set.img"
                alt
                width="100%"
                height="auto"
                @click="openDialog(set)"
              />
              <div class="xx">
                <h2>{{ set.name }}</h2>
                <p>適合人數：{{ set.compatibility }}</p>
                <p>
                  價格 ：
                  <span
                    class="pic"
                    v-if="
                      set.prices === 714
                        ? true
                        : set.prices === 722
                        ? true
                        : set.prices === 108 && set.id === 49
                    "
                    >$&nbsp;&nbsp;{{ set.prices
                    }}<samp style="font-size: 15px">起 免運費</samp></span
                  >
                  <span
                    class="pic"
                    v-else-if="set.prices === 99 || set.prices === 784"
                    >$ {{ set.prices
                    }}<samp style="font-size: 15px">起</samp></span
                  >
                  <span
                    class="pic"
                    v-else-if="set.prices === 108 && set.id === 49"
                    >$&nbsp;&nbsp;{{ set.prices
                    }}<samp style="font-size: 15px">起 免運費</samp></span
                  >
                  <span
                    class="pic"
                    v-else-if="set.prices === 98 && set.id === 1"
                    >$&nbsp;&nbsp;{{ set.prices
                    }}<samp style="font-size: 15px">/盤</samp></span
                  >
                  <span class="pic" v-else-if="set.id === 39">$18 - 45</span>
                  <span v-else-if="cat.name === '2022到會推介' || cat.name=='主打菜單'">$&nbsp;&nbsp;{{ set.prices }}/起</span>
                  <span class="pic" v-else>$&nbsp;&nbsp;{{ set.prices }}</span>
                </p>
                <!-- <div
                  v-for="(type, id) in set.includeTypes"
                  :key="id"
                  class="icons"
                >
                  <span v-if="type === 'Royal card'" class="smlogo R"></span>
                  <span
                    v-if="type === 'suitable for the party'"
                    class="smlogo gg"
                  ></span>
                  <span v-if="type === 'vegan'" class="smlogo b"></span>
                </div> -->
                <el-button type="success" size="mini" @click="openDialog(set)"
                  >查看詳情</el-button
                >
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="zhanmo">
        <el-tabs class="cardmo" type="border-card" style="display: flex">
          <el-tab-pane
            class="card"
            v-for="cat in setMenus"
            :key="cat.id"
            :label="cat.name"
          >
            <div class="cfloat" v-for="set in cat.menusets" :key="set.id">
              <img
                :src="set.img"
                alt
                width="100%"
                height="100%"
                @click="openDialog(set)"
              />
              <div class="xx">
                <p>{{ set.name }}</p>
                <p>適合人數：{{ set.compatibility }}</p>
                <p>
                  價格：
                  <span
                    class="pic"
                    v-if="
                      set.prices === 714
                        ? true
                        : set.prices === 722
                        ? true
                        : set.prices === 108 && set.id === 49
                    "
                    >$&nbsp;&nbsp;{{ set.prices
                    }}<samp style="font-size: 12px">起 免運費</samp></span
                  >
                  <span
                    class="pic"
                    v-else-if="set.prices === 99 || set.prices === 784"
                    >$&nbsp;&nbsp;784<samp style="font-size: 15px"
                      >起</samp
                    ></span
                  >
                  <span
                    class="pic"
                    v-else-if="set.prices === 98 && set.id === 1"
                    >$&nbsp;&nbsp;{{ set.prices
                    }}<samp style="font-size: 15px">/盤</samp></span
                  >
                  <span v-else-if="cat.name === '2022到會推介' || cat.name=='主打菜單'">$&nbsp;&nbsp;{{ set.prices }}/起</span>
                  <span v-else-if="set.id === 39">價格：$ 18 - 45</span>
                  <span class="pic" v-else>$&nbsp;&nbsp;{{ set.prices }}</span>
                </p>
                <p>
                  <el-button type="success" size="mini" @click="openDialog(set)"
                    >查看詳情</el-button
                  >
                </p>
                <!-- <div v-for="(type, id) in set.includeTypes" :key="id" class="icons">
                                    <span v-if="type === 'Royal card'" class="smlogo R"></span>
                                    <span v-if="type === 'suitable for the party'" class="smlogo gg"></span>
                                    <span v-if="type === 'vegan'" class="smlogo b"></span>
                </div>-->
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible2"
      :data="mList"
      open="dialogVisible2 = true"
    >
      <div>
        <div class="menuimg1">
          <div class="posa1">
            <el-button
              class="calla"
              type="success"
              size="small"
              @click="openLink(mList.menu_media[0].Link_app, mList)"
            >
              WhatsApp預訂
            </el-button>
            <el-button
              class="calla"
              type="success"
              size="small"
              @click="openLink(mList.menu_media[0].Link_online, mList)"
              >網上訂購
            </el-button>
          </div>
          <el-image
            style="flex: 0 0 80%"
            :src="mList.menu_media ? mList.menu_media[0].Picture : null"
            width="60%"
            height="100%"
            :preview-src-list="srcList"
          ></el-image>
          <div class="posa1">
            <el-button
              class="calla"
              type="success"
              size="small"
              @click="openLink(mList.Link_app, mList)"
            >
              WhatsApp預訂
            </el-button>
            <el-button
              class="calla"
              type="success"
              size="small"
              @click="openLink(mList.Link_online, mList)"
            >
              網上訂購
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :data="currentSet"
      open="dialogVisible = true"
    >
      <div>
        <div v-for="imgs in currentSet.medias" class="menuimg" :key="imgs.id">
          <img
            v-if="imgs.picture1"
            style="flex: 0 0 30%; border-radius: 10px"
            :src="imgs.picture1"
            width="40%"
            height="100%"
          />
          <img
            v-if="imgs.picture2"
            style="flex: 0 0 30%; border-radius: 10px"
            :src="imgs.picture2"
            width="40%"
            height="100%"
          />
        </div>
        <div class="dialog_center" style="border-radius: 10px">
          <p
            style="
              text-align: center;
              font-size: 1.3rem;
              font-weight: 300;
              margin-bottom: 1rem;
              color: #eb6410;
            "
          >
            {{ currentSet.name }}
          </p>
          <p style="font-size: 15px">
            <span>
              <i class="el-icon-goods"></i>
            </span>
            <span
              v-if="
                currentSet.prices === 714
                  ? true
                  : currentSet.prices === 722
                  ? true
                  : currentSet.prices === 108 && currentSet.id === 49
              "
              >價格：$ {{ currentSet.prices }}起 免運費</span
            >
            <!-- <span v-if="currentSet.prices === 722"
              >價格：$ {{ currentSet.prices }}起 免運費</span
            >
            <span v-if="currentSet.prices === 108 && currentSet.id === 49"
              >價格：$ {{ currentSet.prices }}起 免運費</span
            > -->
            <span v-else-if="currentSet.prices === 98 && currentSet.id === 1"
              >價格：$ {{ currentSet.prices }}/盤</span
            >
            <span v-else-if="currentSet.id === 39">價格：$ 18 - 45</span>
            <span v-else>價格：$ {{ currentSet.prices }}</span>
          </p>
          <p style="font-size: 15px">
            <span>
              <i class="el-icon-s-custom"></i>
            </span>
            <span>適合人數：{{ currentSet.compatibility }}</span>
          </p>
          <p style="font-size: 15px">
            <span>
              <i class="el-icon-s-order"></i>
            </span>
            <span>{{ currentSet.description }}</span>
          </p>
        </div>
        <div class="dialog_bottom">
          <el-form ref="setOrderForm">
            <el-form-item>
              <el-collapse>
                <el-collapse-item
                  class="zd"
                  v-for="(menu, menuId) in this.currentSet.menus"
                  :key="menuId"
                  :title="menu.name"
                >
                  <!-- <el-checkbox-group class="zdz" v-model="selectedMenus[menu['type']]" :max="menu.maximum*2"> -->
                  <div v-for="(item, idx) in menu.items" :key="idx">
                    <!-- <el-checkbox :label="item.id" @change="handleCheckMenuItem(menu, item)">{{item.name}}</el-checkbox>
                    <el-input-number v-if="item.checked" size="small" :min='1' :max='menu.maximum' v-model='item.number' @change="handleChangeMenuItemInput($event, menu, item, idx)"></el-input-number>-->
                    <div class="fff">
                      <span>{{ item.name }}</span>
                      <span v-if="item.price"> ${{ item.price }}</span>
                      <span v-if="item.cover === ''"></span>
                      <span v-else>
                        <img
                          :src="item.cover"
                          alt
                          width="130px"
                          height="90px"
                        />
                      </span>
                    </div>
                  </div>
                  <!-- </el-checkbox-group> -->
                </el-collapse-item>
              </el-collapse>
            </el-form-item>
          </el-form>
        </div>
        <div class="posa">
          <el-button
            class="calla"
            type="success"
            size="mini"
            @click="openLink(currentSet.Link_app, currentSet)"
          >
            WhatsApp預訂
          </el-button>
          <el-button
            class="calla"
            type="success"
            size="mini"
            v-if="this.currentSet.id === 14"
            @click="
              openLink(
                'https://cateraway.rakosell.com/zh/product/10to12happy-7247'
              )
            "
          >
            網上訂購
          </el-button>
          <el-button
            class="calla"
            type="success"
            size="mini"
            v-else
            @click="openLink(currentSet.Link_online, currentSet)"
          >
            網上訂購
          </el-button>
        </div>
      </div>
      <!-- <p style="text-align: center;font-size: 1.5rem;font-weight: 300;margin-bottom: 2rem;color: #eb6410;">~{{currentSet.name}}~</p> -->
      <!-- <div>
              <div v-for="imgs in currentSet.medias" style="display: flex;justify-content: space-around;flex-wrap: wrap;" :key="imgs.id" >
                <img style="flex: 0 0 30%;" :src=imgs.picture1 width="40%">
      <img style="flex: 0 0 30%;" :src=imgs.picture2 width="40%">-->
      <!-- <img style="flex: 0 0 30%;" :src=imgs.picture3 width="100%"> -->
      <!-- </div>
      </div>-->
      <!-- <div class="details">
              <p><i class="el-icon-goods"></i>價格：{{currentSet.prices}}</p>
              <p><i class="el-icon-s-custom"></i>適合人數：{{currentSet.compatibility}}</p>
              <p><i class="el-icon-s-order"></i>内容：{{currentSet.description}}</p>
      </div>-->
      <!-- <hr style="margin:2% 0">
            <div class="dialog-center">
              <el-form ref="setOrderForm">
                <el-form-item>
                  <div v-for="(menu, menuId) in this.currentSet.menus" :key="menuId">
                    <p> {{ menu.name }} </p>
                    <el-checkbox-group v-model="selectedMenus[menu['type']]" :max="menu.maximum*2">
                      <div v-for="(item, idx) in menu.items" :key="idx">
                        <el-checkbox :label="item.id" @change="handleCheckMenuItem(menu, item)">{{item.name}}</el-checkbox>
      <el-input-number v-if="item.checked" size="small" :min='1' :max='menu.maximum' v-model='item.number' @change="handleChangeMenuItemInput($event, menu, item, idx)"></el-input-number>-->
      <!-- <div class="el-input-number" v-if="item.checked"> -->
      <!--左边的减号-->
      <!-- <span class="el-input-number__decrease" @click="del($event, menu, item, idx)">
                              <i class="el-icon-minus"></i>
      </span>-->
      <!--右边的加号-->
      <!-- <span class="el-input-number__increase" @click="add($event, menu, item, idx)">
                              <i class="el-icon-plus"></i>
      </span>-->
      <!--中间的输入框-->
      <!-- <el-input ref="input" v-model='item.number'></el-input> -->
      <!-- </div> -->
      <!-- </div>
                    </el-checkbox-group>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="dialog-bottom"></div>
      <el-button type="success" size="mini" @click="addCart()">加入購物車</el-button>-->
    </el-dialog>
    <el-dialog class="aaa" :visible.sync="yiqing" width="80%">
      <img
        src="../assets/images/fathermenu6-8.png"
        alt
        width="100%"
        height="100%"
      />
    </el-dialog>
    <el-dialog class="aaa" :visible.sync="yiqing2" width="80%">
      <img
        src="../assets/images/father10-12.png"
        alt
        width="100%"
        height="100%"
      />
    </el-dialog>
    <el-dialog class="aaa" :visible.sync="show" width="80%">
      <img :src="src" alt width="100%" height="100%" />
    </el-dialog>
  </div>
</template>

<script>
import header from "../components/header";
import $ from "jquery";
import { menuList } from "../../api/menuList";
// import { login } from "../../api/user";
export default {
  data() {
    return {
      srcList: [],
      imgs: require("../assets/images/caterersmenu2.png"),
      imgs2: require("../assets/images/caterersmenu1.png"),
      yiqing: false,
      yiqing2: false,
      menu: [],
      currentSet: [], // 点击某个按钮，加入对应的数据的数组
      mList: {},
      selectedMenus: {},
      setOrderForm: [],
      cartItems: [],
      dialogVisible: false,
      dialogVisible2: false,
      setMenus: [],
      dialoghref:
        "https://api.whatsapp.com/send?phone=85264586539&text=hello 到會家,我想訂到會！😋😋",
      faMenu: [
        require("../assets/images/fathermenu6-8.png"),
        require("../assets/images/father10-12.png"),
      ],
      ImageData: [
        require("../assets/images/Mid-Autumnmenu6-8.jpg"),
        require("../assets/images/Mid-Autumnmenu10-12.jpg"),
        // "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E8%88%B9p+menu_10ppl.jpg",
        // "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E8%88%B9p+menu_20ppl.jpg",
        // "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E8%88%B9p+menu_30ppl.jpg",
      ],
      imgHeight: "",
      src: "",
      show: false,
    };
  },
  computed: {},
  mounted() {
    // login().then((res) => {
    //   sessionStorage.setItem("token", JSON.stringify(res.data));
    // });
    menuList().then((res) => {
      this.setMenus = res.data;
    });
    this.initData(this.$i18n.locale);
    this.cartItems = this.$store.getters.getCartItems;
    // this.$refs.image[0].onload = () => {
    //   if (this.$refs.image) {
    //     this.imgHeight = this.$refs.image[0].height;
    //   }
    // };
    // this.imgLoad();
    // 监听窗口变化，使得轮播图高度自适应图片高度
    // window.addEventListener("resize", () => {
    //   if (this.$refs.image[0]) {
    //     this.imgHeight = this.$refs.image[0].height;
    //   }
    // });
  },
  methods: {
    imgLoad() {
      this.$nextTick(function () {
        if (this.$refs.image) {
          // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
          this.imgHeight = this.$refs.image[0].height;
        }
      });
    },
    open() {
      if (this.$i18n.locale === "zh") {
        window.open("https://cateraway.rakosell.com/zh", "_blank");
      } else {
        window.open("https://cateraway.rakosell.com/en", "_blank");
      }
    },
    showImage(index) {
      this.show = true;
      // let index = this.$refs.carouselIitem.activeIndex;
      switch (index) {
        case 0:
          this.src = require("../assets/images/2021_ChristmasMenu.jpg");
          break;
        case 1:
          this.src = require("../assets/images/2021_ChristmasMenu.jpg");
          break;
        case 2:
          this.src =
            "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E8%88%B9p+menu_30ppl.jpg";
          break;
      }
    },
    link() {
      const index = this.$refs.carouselIitem.activeIndex;
      var link = document.getElementById("link");
      if (index === 0) {
        link.href =
          "https://cateraway.rakosell.com/zh/product/fathersday68-7656";
      } else {
        link.href =
          "https://cateraway.rakosell.com/zh/product/fathersday810-7657";
      }
    },
    showMonImg(index) {
      if (index === 0) {
        this.yiqing = true;
      } else {
        this.yiqing2 = true;
      }
    },
    initData() {
      this.selectedMenus = {
        salad: [], // 沙律
        staple: [], // 主食
        staple1: [], // 主食1
        staple2: [], // 主食2
        staple3: [], // 主食3
        special: [], // 特式烘焙
        headplate: [], // 頭盤
        pinpan: [], // 小食
        snack: [], // 小食及拼盘
        snack1: [], // 小食及拼盘1
        snack2: [], // 小食及拼盘2
        snack3: [], // 小食及拼盘3
        maindish: [],
        sandwich: [], // 三文治
        vegetables: [],
        dessert: [],
        childrenarea: [], // 小孩子专区
        coldplate: [],
        burger: [], // 迷你汉堡
        addcommodity: [], // 追加
        adddrinks: [], // 追加饮品
        addservice: [], // 追加服务
        surface: [], // 面
        cup: [], // 杯子
        christmas: [],
        addchristmas: [],
        thai: [],
        su: [],
      };
    },
    openLink(link, data) {
      window.open(link, "_blank");
      // this.$router.push({ name: "proDetails", query: { name: data.name } });
    },
    openDialog(data) {
      if (data.menu_media.length !== 0) {
        this.mList = data;
        this.srcList.splice(0, 1, data.menu_media[0].Picture);
        this.dialogVisible2 = true;
      } else {
        this.dialogVisible = true; // 打开dialog
        this.currentSet = data; // 给数组赋数据
      }
    },
    handleCheckMenuItem(menu, item) {
      item.checked = !item.checked;
      if (item.checked) {
        this.selectedMenus[menu.type].push(item);
        item.number++;
        var sum = 0;
        for (var m in menu.items) {
          sum = sum + menu.items[m].number;
        }
        if (sum >= menu.maximum) {
          menu.maximum = 1;
        }
        // this.item.number ++
      } else if (item.checked === false) {
        item.number = 0;
        for (var i in this.selectedMenus[menu.type]) {
          if (item.name === this.selectedMenus[menu.type][i].name) {
            this.selectedMenus[menu.type].splice(i, 1);
          }
        }
      }
    },
    handleChangeMenuItemInput(e, menu, item, index) {
      var sum = 0;
      for (var i in menu.items) {
        sum = sum + menu.items[i].number;
      }
      if (sum >= menu.maximum) {
        menu.maximum = 1;
      }
    },
    addCart() {
      let fulfillSet = true;
      let itemToAdd = this.currentSet; // 点开之后将对应的数据赋给itemTaAdd
      itemToAdd.quantity = 1; // 数量+1
      // 如果有空的数组，则删除
      for (let key in this.selectedMenus) {
        if (this.selectedMenus[key].length === 0) {
          delete this.selectedMenus[key];
        }
      }

      // 将过滤好的数组赋给
      itemToAdd.selected_items = this.selectedMenus;
      if (fulfillSet) {
        this.$store.dispatch("$addItemToCart", itemToAdd);
        this.$nextTick(function () {
          this.dialogVisible = false;
          this.initData();
        });
      }
    },
    bg() {
      $(".Sidebar").css({ left: "-45%", transition: "all 0.8s" });
      $(".bg2").css("display", "none");
    },
    erji() {
      if (this.test) {
        $(".erji").css("display", "block");
        this.test = false;
      } else {
        $(".erji").css("display", "none");
        this.test = true;
      }
    },
    one(val) {
      $("html, body").animate(
        {
          scrollTop:
            $(".m2>div")
              .eq(val - 1)
              .children("p")
              .offset().top - 110,
        },
        1200
      );
    },
    test1(val) {
      $("html, body").animate(
        {
          scrollTop: $(".m2>div:eq(" + (val - 1) + ") > p").offset().top - 110,
        },
        1200
      );
    },
  },
  components: {
    "v-header": header,
  },
};
</script>

<style scope>
.caterers .el-carousel.el-carousel--horizontal {
  flex: 0 0 70%;
  width: 70% !important;
}
.caterers .block {
  width: 80%;
  display: flex;
  justify-content: center;
  margin: 3% auto;
  align-items: center;
}
.Btn {
  padding: 0.6em;
  border-radius: 4px;
  border: 0px;
  background-color: #eb6410;
  color: white;
  margin-top: 1rem;
  width: 10rem;
  cursor: pointer;
}
.caterers .block div:last-child {
  flex: 0 0 30%;
}
.caterers .block div:last-child h2,
.caterers .block div:last-child h3 {
  margin: 5% 0;
}
.caterers .block img {
  width: 75%;
}
.caterers .block {
  flex-wrap: wrap;
}
.caterers .main-section1 {
  padding: 2% 0;
  text-align: center;
}
.caterers .main-section1 > h2 {
  color: #eb6410;
}
.caterers .el-carousel__arrow {
  background-color: #ff5809;
}
/* .caterers .el-carousel__container {
  height: 680px;
} */
.caterers .el-popup-parent--hidden {
  padding-right: 0px !important;
  overflow: inherit;
}
.caterers .el-dialog__body {
  padding: 10px 10px;
}
.caterers .banner {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  background-size: 100% 100%;
  margin: 110px 0 0% 0;
}
.caterers .banner .po {
  width: 100%;
  position: absolute;
  color: white;
  flex: 0 0 100%;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 5px;
}
.caterers .banner img {
  width: 100%;
  height: 100%;
}
.zhan {
  display: block;
  margin: 50px auto 10px auto;
  width: 85%;
}
.caterers .zhan > p {
  text-align: center;
}
.caterers .zhan-c {
  text-align: center;
  font-size: 25px;
  font-weight: 400;
  margin: 0 0 5% 0;
}
.zhanmo {
  display: none;
}
.suoyin {
  display: none;
}
.caterers {
  background: #fff;
  overflow: hidden;
}
.bg2 {
  background: rgba(20, 20, 21, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 3;
  top: 0;
  display: none;
}
.center2 {
  height: 100%;
  width: 80%;
  margin: auto;
}
/* 主体内容 */
.caterers-c {
  margin: 110px 0 0 0;
  padding: 1% 0;
  background: #fff;
}
.caterers-c > .center {
  width: 85%;
  float: left;
}
.main {
  width: 95%;
  margin: auto;
}
.Sidebar {
  box-sizing: border-box;
  padding: 0.5% 0.5% 0 0;
  position: fixed;
  top: 25%;
  left: 0;
  width: 14%;
  z-index: 3;
}
.s1,
.s2 {
  padding: 3% 0;
}
.s1 > p {
  color: #fff;
  text-shadow: 0px 0px 20px #eb6410;
  font-size: 35px;
  font-weight: 500;
  margin: 2rem 0;
  text-indent: 2rem;
}
.s2 {
  display: flex;
  flex-direction: column;
}
.s2 p {
  border-radius: 0 20px 20px 0;
  background: rgba(76, 91, 82, 0.4);
  color: #fff;
  cursor: pointer;
  margin: 0.2rem 0;
  height: 4rem;
  line-height: 4rem;
  box-sizing: border-box;
  padding: 0 0 0 5%;
  transition: all 0.5s;
}
.s2 p:hover {
  background: #eb6410;
  transition: all 0.5s;
}
.s2 p span {
  display: inline-block;
  margin-left: 0.1rem;
}
.m1 > p {
  height: 42px;
  line-height: 42px;
}
.m2 > div {
  margin: 0 0 3% 0;
}
.sm1 {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
}
.sm1 > div {
  cursor: pointer;
  margin: 1% 0;
  box-shadow: 0px 4px 5px rgba(43, 7, 21, 0.5);
  flex: 0 0 27.16%;
  max-width: 32.16%;
  margin: 1% 2.75%;
  box-sizing: border-box;
  border-radius: 0 0 2% 2%;
}
.sm1 > div:hover {
  box-shadow: 0px 4px 5px #e6a23c;
}
.sm1 > div img {
  border-radius: 2% 2% 0 0;
}
.xx {
  font-size: 0.7rem;
  color: #95989d;
  box-sizing: border-box;
  padding: 0 5%;
}
.xx > p {
  margin: 3% 0;
  font-size: 0.8rem;
}
.xx > h2 {
  color: #eb6410;
  font-size: 1.1rem;
}
.xx > button {
  float: right;
  margin-bottom: 1rem;
  background: #eb6410;
  border: 1px solid #eb6410;
}
.xx > p:nth-child(3) {
  height: 30px;
  text-align: right;
}
.sty1 {
  font-weight: 200;
  color: #eb6410;
  font-size: 18px;
  margin: 2% 0;
}
.sty2 {
  color: #000;
  font-size: 14px;
  font-weight: 300;
  margin: 2px 0;
}
.icons {
  display: inline !important;
}
.smlogo {
  width: 25px;
  height: 25px;
  display: inline-block;
  border-radius: 50%;
}
.smlogo i {
  margin: 20% 20%;
  font-size: 1rem;
  color: #fff;
}
.smlogo.R {
  background: url("../assets/images/huangpai.png");
  background-size: 100% 100%;
}
.caterers .smlogo.gg {
  background: url("../assets/images/paidui.png");
  background-size: 100% 100%;
}
.caterers .smlogo.b {
  background: url("../assets/images/sushi.png");
  background-size: 100% 100%;
}
.caterers .pic {
  color: #b33d02;
  font-size: 15px;
}
.caterers .bbg {
  box-shadow: 1px 1px 10px #888e95;
  background-size: 100% 100%;
}
/* 广告 */
.caterers .banner .el-button.el-button--success {
  display: block;
  width: 10rem;
  margin: 2% auto 0 auto;
}

.caterers .bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  background: rgba(20, 20, 21, 0.5);
}
.caterers .banner h1,
.caterers .banner h2 {
  color: #fff;
  width: 70%;
  margin: auto;
}
.caterers .banner h1 {
  font-size: 4vw;
  margin: 0 auto 20px auto;
  font-weight: 400;
}
.caterers .banner h2 {
  font-size: 2.5vw;
  font-weight: 400;
}
.caterers .zhan .zhanh2 {
  font-weight: 400;
  display: inline-block;
  font-size: 1.4vw;
}
.caterers .zhan .zhanh22 {
  font-size: 13px;
  color: #212121;
}
/* 参数 */
.services {
  background: #fff;
  /* height: 110px; */
  padding: 2% 0;
  border-bottom: 1px solid #dbdbdb;
}

.services ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.services ul li {
  flex-direction: row;
  flex: 0 0 24%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.services ul li > p:nth-child(1) {
  flex: 0 0 20%;
}
.services ul li > p:nth-child(1) img {
  width: 100%;
}
.services ul li > p:nth-child(2) {
  flex: 0 0 70%;
}
.services ul li > p:nth-child(2) span {
  display: block;
  width: 60%;
  padding: 0 5%;
}

.services li span:nth-child(1) {
  font-size: 20px;
  margin-bottom: 10px;
}

.services li span:nth-child(2) {
  float: left;
  display: block;
  padding: 0 5%;
  font-size: 13px;
  color: #919599;
}

.services li span:nth-child(1) i {
  font-size: 1.5rem;
  display: inline-block;
  margin: 25% 25%;
}

.m2 > div > p {
  text-align: center;
  font-size: 1.7rem;
  font-weight: 500;
  margin: 2.4rem 0;
  color: #eb6410;
  letter-spacing: 0;
}

.icon {
  display: none;
}

.diag-top {
  overflow: hidden;
}

.diag-top > div {
  margin: 1rem 0;
  float: left;
  width: 50%;
  padding: 0 2%;
  box-sizing: border-box;
}

.d-t-left > p {
  margin: 5% 0;
}

.diag-center {
  margin: 3rem 0;
}

.el-dialog__body .el-button.el-button--success.el-button--mini {
  /* margin: 1.5rem auto 0 auto; */
  display: block;
}

.caterers .el-dialog {
  margin-top: 10vh !important;
  width: 60%;
}

.caterers .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.caterers .el-checkbox {
  flex: 0 0 48%;
  margin-right: 0;
}

.caterers .el-checkbox-group > div {
  flex: 0 0 48%;
}

.caterers .el-input-number--mini {
  margin-left: 0.5rem;
  width: 80px;
  display: none;
}

.dialog-top {
  overflow: hidden;
}

.d-t-left {
  display: flex;
  flex-wrap: wrap;
  width: 65%;
  float: left;
  padding-right: 1%;
  box-sizing: border-box;
}

.d-t-left > div {
  flex: 1 0 50%;
  padding: 0 10px;
  box-sizing: border-box;
}

.d-t-right {
  width: 30%;
  float: left;
}

.calla {
  color: white;
  text-decoration: none;
  font-size: 1rem;
}

.caterers .zhan-c img {
  padding: 0 0 5px 0;
}

.el-form-item__content > div > p {
  font-weight: 200;
  color: #eb6410;
  font-size: 18px;
}

.details {
  width: 60%;
  margin: 3% auto;
  font-size: 1rem;
  line-height: 2rem;
  font-weight: 300;
  border-top: 1px dashed;
  padding: 1%;
}

.details i {
  margin-right: 3%;
  color: #eb6410;
}

.caterers .el-input-number--small {
  margin-left: 1rem;
}
.caterers .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.65);
}
.caterers .dialog_center {
  width: 50%;
  margin: 15px auto;
  background: #f0f0f0;
  padding: 15px;
  box-sizing: border-box;
}

.caterers .dialog_center i {
  color: #eb6410;
  margin: 0 20px 0 0;
}

.caterers .dialog_center p {
  margin: 10px 0;
  padding: 0 30px;
  overflow: hidden;
}

.caterers .dialog_center p > span {
  display: inline-block;
  float: left;
}

.caterers .dialog_center p > span:nth-child(1) {
  width: 10%;
}

.caterers .dialog_center p > span:nth-child(2) {
  width: 90%;
}

.caterers .el-collapse-item.zd > div > div {
  font-size: 15px;
  color: #eb6410;
}

.caterers .fff {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.caterers .fff > span {
  display: inline-block;
  flex: 0 0 100%;
}

.caterers .el-checkbox-group.zdz > div {
  margin: 10px 0;
}

.caterers .el-form-item__content {
  width: 95%;
  margin: auto;
}
.menuimg,
.menuimg1 {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.caterers .epidemic-c {
  width: 50%;
  margin: 3% auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.caterers .epidemic-c > div:nth-child(1) {
  flex: 0 0 33%;
  text-align: center;
}
.caterers .epidemic-c > div:nth-child(2) {
  flex: 0 0 60%;
  /* padding: 3%; */
  text-align: center;
}
.caterers .epidemic-c > div:nth-child(3) {
  flex: 0 0 33%;
  /* padding: 3% 0; */
  text-align: center;
}
.caterers .epidemic-c > div:nth-child(2) > p {
  font-weight: 600;
  margin-bottom: 2%;
}
.caterers .epidemic-c > div:nth-child(2) > p:nth-child(1) {
  font-size: 30px;
}
.caterers .epidemic-c > div:nth-child(2) > p:nth-child(3) {
  font-size: 14px;
}
.caterers .epidemic-c > div:nth-child(2) > a button {
  background: #ec601c;
  border: 1px solid #ec601c;
  color: #fff;
  width: 200px;
  margin-top: 30px;
}
.caterers .epidemic-c > div:nth-child(1) img {
  width: 80%;
}
.caterers .epidemic-c > div:nth-child(3) img {
  width: 80%;
}
.caterers .el-dialog__wrapper.aaa {
  background: rgba(20, 20, 21, 0.5);
}
.caterers .el-dialog__wrapper.aaa .el-dialog {
  margin-top: 3vh !important;
}
.caterers .caterers_menu {
  width: 60%;
  /* margin: 5% auto; */
}
.caterers .caterers_menu_f {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.caterers .caterers_menu_f:nth-child(1) {
  margin-bottom: 5%;
}
.caterers .caterers_menu_f > div:nth-child(1) {
  flex: 0 0 65%;
  text-align: center;
}
.caterers .caterers_menu_f > div:nth-child(1) img {
  width: 60%;
  height: 100%;
}
.caterers .caterers_menu_f > div:nth-child(2) {
  flex: 1;
  text-align: center;
}
.caterers .caterers_menu_f > div:nth-child(2) h3 {
  margin-bottom: 6%;
}
.caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(1) {
  font-size: 1.5vw;
}
.caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(2) {
  font-size: 1vw;
}
.caterers .caterers_menu_f > div:nth-child(2) button {
  background: #eb6410;
  border: 1px solid #eb6410;
  color: #fff;
}
/* 移动端 */

@media (max-width: 1500px) {
  .caterers .caterers_menu_f > div:nth-child(1) img {
    width: 75%;
  }
  .caterers .epidemic-c > div:nth-child(2) > p:nth-child(1) {
    font-size: 25px;
  }
  .caterers .caterers_menu {
    width: 50%;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(1) {
    font-size: 1.9vw;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(2) {
    font-size: 1.2vw;
  }
}
@media (max-width: 1400px) {
  .caterers .caterers_menu_f > div:nth-child(1) img {
    width: 80%;
  }
}
@media (max-width: 1275px) {
  .sm1 > div {
    flex: 0 0 28.16;
    max-width: 57.16%;
  }
  .caterers .epidemic-c > div:nth-child(2) > p:nth-child(1) {
    font-size: 26px;
  }
  .caterers .epidemic-c > div:nth-child(2) > p:nth-child(3) {
    font-size: 12px;
  }
  .services li span:nth-child(1) {
    font-size: 16px;
  }
  .caterers .epidemic-c {
    width: 90%;
  }
  .caterers .caterers_menu {
    width: 70%;
  }
}
@media (max-width: 1110px) {
  .sm1 > div {
    flex: 1 0 35%;
  }
  .caterers .epidemic-c > div:nth-child(2) > p:nth-child(1) {
    font-size: 22px;
  }
  .caterers .epidemic-c > div:nth-child(2) > p:nth-child(3) {
    font-size: 12px;
  }
  .services ul li > p:nth-child(2) span {
    width: auto;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(1) {
    font-size: 2.3vw;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(2) {
    font-size: 1.5vw;
  }
}
</style>
<style>
.el-tabs__nav {
  white-space: break-spaces;
}
.caterers .posa,
.posa1 {
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin-top: 4%; */
  margin: 2% 0;
  flex: 0 0 80%;
}
.caterers .posa .el-button--success,
.caterers .posa1 .el-button--success {
  background-color: #eb6410;
  border-color: #eb6410;
  margin: 0 3%;
}
.caterers .posa1 .el-button--success {
  flex: 0 0 47%;
}
.caterers .el-collapse-item__content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.caterers .el-collapse-item__content > div {
  flex: 0 0 45%;
  color: black;
  margin: 10px 0;
}
.caterers .el-tab-pane.card {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}
.caterers .el-tabs.el-tabs--top.el-tabs--border-card {
  border: none;
  box-shadow: none;
}
.caterers .el-tabs__header.is-top {
  background: none;
  border: none;
}
.caterers .el-tabs__item.is-top.is-active {
  border: none;
}
.caterers .el-tabs--border-card > .el-tabs__header .el-tabs__item {
  border: 1px solid;
  border-radius: 10px;
  margin: 10px;
}
.caterers .el-tabs__nav.is-top {
  width: 100%;
  text-align: center;
}
.caterers .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background: #eb6410;
  color: white;
  border-radius: 10px;
  margin-bottom: 20px;
}
.caterers
  .el-tabs--border-card
  > .el-tabs__header
  .el-tabs__item:not(.is-disabled):hover {
  background: #eb6410;
  color: white;
  border-radius: 10px;
}
.caterers .el-tab-pane.card > div {
  flex: 0 0 22%;
  margin: 0 10px 20px 10px;
  box-sizing: border-box;
  cursor: pointer;
}
@media (max-width: 1450px) {
  .caterers .zhan .zhanh2 {
    font-size: 2vw;
  }
}
@media (max-width: 1265px) {
  .caterers .banner .po {
    letter-spacing: 5px;
  }
  .caterers .banner h1,
  .caterers .banner h2 {
    width: 90%;
  }
  .caterers .el-dialog {
    width: 85%;
  }
}
@media (max-width: 1265px) {
  .caterers .zhan {
    width: 98%;
  }
  .caterers .zhan .zhanh2 {
    font-size: 2.5vw;
  }
  .caterers .caterers_menu_f > div:nth-child(1) img {
    width: 75%;
  }
}
@media (max-width: 890px) {
  .caterers .caterers_menu_f > div:nth-child(1) img {
    width: 85%;
  }
  /* .caterers .el-carousel__container {
    height: 500px !important;
  } */
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(1) {
    font-size: 2.5vw;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(2) {
    font-size: 1.9vw;
  }
}
@media (max-width: 800px) {
  .caterers .caterers_menu {
    width: 90%;
  }
  .caterers
    .main-section1
    .block
    > .caterers
    .el-carousel.el-carousel--horizontal {
    flex: 0 0 80%;
  }
  .caterers .main-section1 .block > div:last-child {
    flex: 0 0 100%;
  }
}
@media (max-width: 768px) {
  .caterers .caterers_menu_f > div:nth-child(1) img {
    width: 70%;
  }
  .caterers .caterers_menu_f > div:nth-child(1) {
    flex: 0 0 100%;
  }
  .caterers .caterers_menu_f > div:nth-child(2) {
    flex: 0 0 100%;
    padding: 5% 0;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3 {
    margin-bottom: 10px;
  }
  .caterers .el-dialog {
    width: 90%;
  }
  .caterers .epidemic-c > div:nth-child(1),
  .caterers .epidemic-c > div:nth-child(2),
  .caterers .epidemic-c > div:nth-child(3) {
    flex: 0 0 100%;
    margin-bottom: 10px;
  }
  .caterers .bbg {
    padding: 0;
  }
  .caterers .banner h1 {
    font-size: 4vw;
  }
  .caterers .banner h2 {
    font-size: 3vw;
  }
  .caterers .el-tab-pane.card > div {
    flex: 0 0 45%;
  }
  .caterers .zhan .zhanh2 {
    font-size: 2.8vw;
  }
  .caterers .zhan-c img {
    width: 20%;
  }
  .caterers .epidemic-c {
    width: 90%;
  }
}
@media (max-width: 700px) {
  .services ul li {
    flex: 0 0 49%;
    margin: 0 0 30px 0;
  }
  .caterers .pic {
    font-size: 12px;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(1) {
    font-size: 3vw;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(2) {
    font-size: 2.3vw;
  }
}
@media (max-width: 480px) {
  .caterers .main-section1 .el-carousel.el-carousel--horizontal {
    width: 90% !important;
    flex: 0 0 100%;
  }
  .caterers .caterers_menu_f > div:nth-child(1) img {
    width: 80%;
  }
  /* .caterers .el-carousel__container {
    height: 380px !important;
  } */
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(1) {
    font-size: 5vw;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3:nth-child(2) {
    font-size: 4vw;
  }
  .caterers .caterers_menu_f > div:nth-child(1) {
    flex: 0 0 100%;
  }
  .caterers .caterers_menu_f > div:nth-child(2) {
    flex: 0 0 100%;
    padding: 5% 0;
  }
  .caterers .caterers_menu_f > div:nth-child(2) h3 {
    margin-bottom: 10px;
  }
  .xx {
    padding: 0 0 0 5%;
  }
  .caterers .services ul li > p:nth-child(1) {
    flex: 0 0 30%;
  }
  .caterers .el-collapse-item__content > div {
    flex: 0 0 100%;
  }
  .caterers .cardmo.el-tabs.el-tabs--top.el-tabs--border-card {
    overflow: hidden;
  }
  .caterers .cardmo.el-tabs.el-tabs--top.el-tabs--border-card > div {
    float: left;
  }
  .caterers
    .cardmo.el-tabs.el-tabs--top.el-tabs--border-card
    > div:nth-child(1) {
    width: 36%;
    box-sizing: border-box;
    background: #f4f7fb;
  }
  .caterers
    .cardmo.el-tabs.el-tabs--top.el-tabs--border-card
    > div:nth-child(2) {
    width: 80%;
    box-sizing: border-box;
    padding: 0 5px;
  }
  .caterers
    .cardmo.el-tabs.el-tabs--top.el-tabs--border-card
    > div:nth-child(1)
    .el-tabs__nav.is-top
    > div {
    font-size: 12px;
    display: block;
    border-radius: 0;
    margin: 0;
    border: none;
    height: 40px;
    line-height: 40px;
    padding: 0 5px;
    overflow: scroll;
  }
  .caterers .el-input-number--small {
    margin-right: 0;
  }
  .caterers .zhanmo .el-tab-pane.card > div {
    flex: 0 0 100%;
    border-radius: 5px;
  }
  .caterers .el-dialog__body {
    padding: 30px 10px;
  }
  .caterers .cfloat > div {
    float: left;
    width: 55%;
    height: auto;
  }
  .caterers .cfloat {
    overflow: hidden;
  }
  .caterers .cfloat > img {
    float: left;
    width: 45%;
    box-sizing: border-box;
  }
  .caterers .xx > p:nth-child(1) {
    font-size: 12px;
  }
  .caterers .xx > p:nth-child(3) {
    text-align: left;
  }
  .caterers .xx button {
    font-size: 12px;
    background: #eb6410;
    border: 1px solid #eb6410;
  }
  .caterers .el-dialog__header {
    position: absolute;
    background: #fff;
    width: 88%;
    z-index: 999;
  }
  .caterers .el-dialog__body {
    margin-top: 20px;
  }
  .caterers .el-checkbox-group > div {
    flex: 1 0 51%;
  }
  .el-icon-caret-left {
    left: 0;
    top: 4.5rem;
  }
  .el-icon-caret-right {
    right: 0;
    top: 4.5rem;
  }
  .caterers .banner h1 {
    font-size: 6vw;
    margin: 0 auto 10px auto;
  }
  .caterers .banner h1,
  .caterers .banner h2 {
    width: 90%;
    letter-spacing: 5px;
  }
  .caterers .banner h2 {
    font-size: 5vw;
  }
  .caterers .zhan {
    display: none;
  }
  .caterers .details {
    width: 93%;
    font-size: 14px;
  }
  .caterers .caterers-c > .center {
    width: 100%;
  }
  .caterers .banner {
    margin: 135px 0 0 0;
  }
  .caterers .banner p:nth-child(1) {
    font-size: 28px;
  }
  .caterers .banner p {
    width: 80%;
  }
  .caterers .banner p:nth-child(2) {
    font-size: 18px;
  }
  .caterers .icon {
    display: block;
    position: absolute;
    right: -1.5rem;
    top: 50%;
    background: #9e9c9c;
    border-radius: 50%;
  }
  .icon i {
    display: inline-block;
    font-size: 2rem;
  }
  .Sidebar {
    display: none;
    background: beige;
    width: 45%;
    position: fixed;
    z-index: 4;
    left: -45%;
    top: 0;
    height: 100%;
  }
  .phone-header-top {
    display: block;
  }
  header {
    height: 60px;
  }
  .header-bottom {
    display: none;
  }
  .header-top {
    display: none;
  }
  .center {
    width: 100%;
  }
  .services ul {
    transform: translate(0, 0%);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .services ul li {
    text-align: center;
    flex: 0 0 50%;
    margin: 3% 0;
    padding: 0 10px;
    box-sizing: border-box;
  }
  .services li span:nth-child(1) {
    display: block;
    margin: 0 auto 5%;
    float: none;
  }
  .services img {
    width: 40px;
    height: 40px;
  }
  .services li span:nth-child(2) {
    width: 100%;
    padding: 0 5%;
    text-align: center;
    font-size: 20px;
  }
  .services ul {
    margin: 17px 0 0;
  }
  .services li span:nth-child(2),
  .parameter li span:nth-child(3) {
    width: 100%;
    font-size: 13px;
    padding: 0;
  }
  .zhanmo {
    display: block;
    margin: 10px 0 0 0;
  }
  .services li span:nth-child(3) {
    font-size: 12px;
    width: 90%;
  }
  .banner .center {
    width: 95%;
    height: 20%;
  }
  .caterers .banner .center h1 {
    font-size: 2rem;
  }
  .banner p {
    margin: 1% 0;
    font-size: 13px;
  }
  .banner .el-button.el-button--success {
    display: block;
    width: 10rem;
    margin: 5% auto 0 auto;
  }
  .content > div > div {
    display: flex;
    flex-direction: column;
  }
  .content > div > div > div {
    margin: 0 auto 1rem auto;
  }
  .menu-more > div {
    flex: 1 0 40%;
  }
  .menu-more > div > div > p {
    display: none;
  }
  .caterers .menu-more {
    padding: 0 15px;
  }
  .main {
    width: 100%;
  }
  .sm1 > div {
    flex: none;
    max-width: 90%;
    min-width: 90%;
    margin: 5% auto;
    padding: 0;
  }
  .caterers .el-dialog {
    width: 100% !important;
    /* margin: 0 !important; */
    overflow: auto;
    /* height: 80%; */
  }
  .diag-top > div {
    width: 100%;
    float: none;
  }
  .parameter3 li span:nth-child(2) {
    font-size: 12px;
  }
  .parameter3 li span:nth-child(1) {
    margin: 0 0 0 38%;
  }
  .el-checkbox {
    white-space: inherit;
  }
  .top .el-dialog__body {
    padding: 0 1%;
  }
  .s2 p span {
    font-size: 14px;
  }
  .s2 {
    padding: 3% 5%;
  }
  .suoyin {
    display: block;
    position: fixed;
    top: 60px;
    z-index: 10;
    background: #353333ba;
    width: 100%;
    height: 40px;
    line-height: 40px;
  }
  .suoyin > ul {
    display: flex;
    flex-wrap: nowrap;
    overflow: auto;
  }
  .suoyin > ul::-webkit-scrollbar {
    display: none;
  }
  .suoyin > ul > li {
    flex: 1 0 34.33%;
    text-align: center;
    color: #fff;
    font-size: 12px;
  }
  .suoyin > ul > li:nth-child(3) {
    position: relative;
  }
  .erji {
    display: none;
    top: 41px;
    background: #9e9c9c;
    width: 120px;
    position: absolute;
  }
  .erji > li {
    color: #fff;
    border-bottom: 1px solid #fff;
    display: block;
    width: 100%;
  }
  .caterers .el-checkbox {
    flex: 1 0 51%;
  }
  .center2 {
    width: 100%;
  }
  .suoyin i {
    position: fixed;
  }
  .d-t-left,
  .d-t-right {
    width: 100%;
    text-align: center;
  }
  .d-t-left > div {
    flex: 1 0 51%;
  }
  .d-t-right {
    margin-top: 5%;
  }
  .caterers .dialog_center {
    width: 90%;
  }
  .caterers .dialog_center p:nth-child(1) {
    font-size: 1.2rem !important;
  }
  .caterers .dialog_center p {
    padding: 0 10px;
    font-size: 0.8rem !important;
  }
  .menuimg {
    height: 130px;
  }
  .menuimg1 {
    height: 100%;
  }
  .caterers .epidemic-c {
    width: 90%;
    margin: 30px auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
  .caterers .epidemic-c > div:nth-child(1) {
    margin-bottom: 20px;
  }
  .caterers .epidemic-c > div:nth-child(3),
  .caterers .epidemic-c > div:nth-child(2),
  .caterers .epidemic-c > div:nth-child(1) {
    flex: 0 0 100%;
    text-align: center;
  }
  .caterers .epidemic-c > div:nth-child(2) > p:nth-child(1) {
    font-size: 25px;
  }
  .caterers .epidemic-c > div:nth-child(2) > p:nth-child(3) {
    font-size: 12px;
  }
  .caterers .epidemic-c > div:nth-child(2) > button {
    margin-top: 10px;
  }
  .caterers .epidemic-c > div:nth-child(3) {
    margin-top: 30px;
    padding: 0;
  }
  .caterers .epidemic-c > div:nth-child(3) img,
  .caterers .epidemic-c > div:nth-child(1) img {
    width: 90%;
  }
}
</style>
